import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const tenantCodesRoutes = [
  {
    path: 'codes',
    component: () => import('@/features/superAdmin/tenantCodes/TenantCodes.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.CodesView,
    },
  },
  {
    path: 'codes/:id',
    component: () => import('@/features/superAdmin/tenantCodes/TenantCodeDetail.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.CodesView,
    },
  },
]
